export class StringHelper {
    public static toSnakeCase(input: string): string {
        return input.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
    }

    public static replaceContentFrom(str: string, start: string, end: string, replaceValue: string): string {
        const varPattern = new RegExp(`${start}.*?${end}`, 'g');

        return str.replace(varPattern, replaceValue);
    }

    public static removePatternFromString(str: string, patterns: string[]): string {
        patterns.forEach((pattern) => {
            str = str.replace(pattern, '');
        });

        return str;
    }
}
